/*
<div onChange={handleRadioBtn}>
  <Radio value="Value Text" name="name" text="Label Text" />
  <Radio value="Value Text" name="name" text="Label Text" />
</div>
*/
import React from "react";
import styled from "styled-components";

const RadioBtn = ({ className, checked, ...props }) => (
  <RadioStyle className={className} alert={props.alert}>
    <StyledLabel alert={props.alert}>
      <HiddenRadio checked={checked} {...props} />
      <StyledRadio checked={checked} alert={props.alert}>
        <svg viewBox="0 0 24 24">
          <circle cx="50%" cy="50%" r="5" />
        </svg>
      </StyledRadio>
      {props.text}
    </StyledLabel>
  </RadioStyle>
);
export default RadioBtn;

const RadioStyle = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;

  & ~ span {
    font-size: 14px;
    user-select: none;
    font-weight: normal;
    font-family: "Poppins Regular";
    color: ${({ theme, alert }) => (alert ? theme.color.danger : theme.color.lighterText)};
  }
`;

const HiddenRadio = styled.input.attrs({ type: "radio" })`
  display: none;
`;

const StyledRadio = styled.div`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  margin-right: 8px;
  position: relative;
  top: 3px;
  background-color: ${(props) =>
    props.alert ? "rgba(238, 76, 80, 0.1)" : props.theme.color.secondaryBg};
  border-radius: 50px;
  transition: all 150ms;

  ${HiddenRadio}:focus + & {
    box-shadow: 0 0 0 3px ${(props) => props.theme.color.secondaryBg};
  }
`;

const StyledLabel = styled.label`
  display: flex;
  align-items: flex-start;
  font-family: "Poppins Regular";
  cursor: pointer;
  color: ${(props) => (props.alert ? "rgba(238, 76, 80)" : props.theme.color.lighterText)};

  svg circle {
    visibility: hidden;
    fill: white;
  }

  ${HiddenRadio}:checked + ${StyledRadio} {
    background-color: ${({ theme }) => theme.color.primary};
  }
  ${HiddenRadio}:checked + ${StyledRadio} svg circle {
    visibility: visible;
  }
`;
